import React, { useState } from 'react';
import cx from 'classnames';
import { useIntl } from 'react-intl';

import { BlockDataForm } from '@plone/volto/components/manage/Form';
import { default as SidebarPortal } from '@plone/volto/components/manage/Sidebar/SidebarPortal';

import StringToHTML from '../../StringToHTML/StringToHTML';
import { buttonBlockSchema } from './featured_schema_enhancer';
import { emptyButtons } from './utils';
import config from '@plone/volto/registry';
import { isEmpty } from 'lodash';

const FeaturedView = (props) => {
  const { data, selected, onChangeBlock, block, className, style } = props;
  const HeadingTag = 'h1';
  const href = data.href?.[0];
  const image = data.preview_image?.[0];
  const Image = config.getComponent('Image').component;
  const [selectedButtonBlock, setSelectedButtonBlock] = useState(-1);
  const intl = useIntl();
  const properties = isEmpty(data?.buttons?.blocks)
    ? emptyButtons(1)
    : data.buttons;
  React.useEffect(() => {
    if (isEmpty(data?.buttons)) {
      onChangeBlock(block, {
        ...data,
        buttons: {
          ...properties,
        },
      });
    }
    /* eslint-disable-next-line */
  }, []);

  return (
    <div className={cx('featured-image-right', className)} style={style}>
      <div className="featured-content">
        <div
          className="featured-title-description-wrapper"
          onClick={() => setSelectedButtonBlock(-1)}
          onKeyDown={() => setSelectedButtonBlock(-1)}
          tabIndex={0}
          role="button"
        >
          <div className="featured-title-description">
            <HeadingTag>
              {data.richtitle && (
                <StringToHTML string={data?.richtitle?.data} />
              )}
            </HeadingTag>
            <div className="featured-description">
              <p>{data?.description2}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="featured-image">
        <Image
          item={image || href}
          imageField={image ? image.image_field : href}
          alt={data.title}
          responsive={true}
        />
      </div>

      <SidebarPortal
        selected={
          selected && selectedButtonBlock !== -1 && data.buttons?.blocks
        }
      >
        <BlockDataForm
          schema={buttonBlockSchema(intl)}
          title="Button block"
          onChangeField={(id, value) => {
            onChangeBlock(block, {
              ...data,
              buttons: {
                ...data.buttons,
                blocks: {
                  ...data.buttons.blocks,
                  [selectedButtonBlock]: {
                    ...data.buttons.blocks[selectedButtonBlock],
                    [id]: value,
                  },
                },
              },
            });
          }}
          formData={data.buttons?.blocks?.[selectedButtonBlock]}
        />
      </SidebarPortal>
    </div>
  );
};

export default FeaturedView;
